<template>
  <div class="key-box" @click="copyKey">
    <p>Your api key is:</p>
    <div class="copy-clipboard-wrapper">
      <label for="api-key"></label>
      <input :value="apiKey"
             type="text"
             id="api-key"
             class="form-input"
             readonly/>
      <font-awesome-icon icon="clipboard" class="fa-clipboard clipboard-icon"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "KeyBox",
    props: {
      apiKey: {
        type: String,
        required: true,
      },
      copyToClipboard: {
        type: Function,
        required: true
      }
    },
    methods: {
      copyKey: function () {
        this.$props.copyToClipboard();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/_base.variables.scss";
  @import "../../assets/css/base.mixins";

  .key-box {
    margin-top: 25px;
  }

  .copy-clipboard-wrapper {
    position: relative;

    .clipboard-icon {
      @include position(absolute, $top: 50%, $right: 10px);
      transform: translateY(-50%);
    }

    .form-input {
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }

    &:hover {
      cursor: pointer;

      .clipboard-icon {
        color: $dtt-main
      }
    }
  }
</style>
